import store from '../store'
import Block from './Block'

export default class Showreel extends Block {
  getElems() {
    super.getElems()

    this.cta = this.el.querySelector('.c-showreel__cta')
    this.buttons = document.querySelectorAll('a[href$="#showreel"]')
  }

  events() {
    super.events()

    for (let i = 0; i < this.buttons.length; i++) this.buttons[i].addEventListener('click', this.onClick.bind(this))
    this.cta.addEventListener('click', this.onClick.bind(this))
  }

  onClick() {
    store.showreel.show()
  }
}
